import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { enumDocumentType } from '@app/data-layer/enums/documents';
import { DocumentPreviewModel } from '@app/data-layer/models/documents';
import { DocumentsRepository } from '@app/data-layer/repositories';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-document-preview-box',
  templateUrl: './document-preview-box.component.html',
  styleUrls: ['./document-preview-box.component.scss'],
})
export class DocumentPreviewBoxComponent implements OnChanges {
  @Input() public open: boolean = false;
  @Input() public isShowDeleteButton: boolean = true;
  @Input() public nonDeletableTypes: enumDocumentType[] = [];
  @Input() public index: number;
  @Input() public previewDocs: DocumentPreviewModel[] = [];

  @Output() public delete: EventEmitter<{ docId: number; shipmentId: number }> = new EventEmitter<{ docId: number; shipmentId: number }>();
  @Output() public close: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('downloadLink', { static: false }) public downloadLinkRef: ElementRef;

  public currentlyPreviewed: DocumentPreviewModel;
  public currentlyPreviewedIndex: number = 0;

  constructor(private documentsRepository: DocumentsRepository) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.open) {
      this.currentlyPreviewedIndex = this.index;
      this.setCurrentlyPreviewed();
    }
  }

  public onDeleteDocument() {
    if (!this.currentlyPreviewed) {
      return;
    }

    this.delete.emit({
      docId: this.currentlyPreviewed.id,
      shipmentId: this.currentlyPreviewed.shipmentId,
    });

    this.onClose();
  }

  public onDownloadDocument() {
    if (!this.currentlyPreviewed) {
      return;
    }

    this.documentsRepository
      .getDownloadLink(this.currentlyPreviewed.id)
      .pipe(take(1))
      .subscribe((linkData: { downloadUrl: string }) => {
        this.downloadLinkRef.nativeElement.href = linkData.downloadUrl;
        this.downloadLinkRef.nativeElement.click();
      });
  }

  public onNavigate(direction: 'left' | 'right') {
    switch (direction) {
      case 'left':
        if (this.currentlyPreviewedIndex > 0) {
          this.currentlyPreviewedIndex--;
        }
        break;
      case 'right':
        if (this.currentlyPreviewedIndex < this.previewDocs.length - 1) {
          this.currentlyPreviewedIndex++;
        }
        break;
      default:
        break;
    }

    this.setCurrentlyPreviewed();
  }

  public onClose() {
    this.close.emit();
  }

  public get shouldShowDeleteButton(): boolean {
    return this.isShowDeleteButton && !this.nonDeletableTypes.includes(this.currentlyPreviewed?.type);
  }

  public get isFirstPreviewedDocument(): boolean {
    return this.currentlyPreviewedIndex <= 0;
  }

  public get isLastPreviewedDocument(): boolean {
    return this.currentlyPreviewedIndex >= this.previewDocs.length - 1;
  }

  private setCurrentlyPreviewed() {
    if (this.previewDocs.length) {
      this.currentlyPreviewed = this.previewDocs[this.currentlyPreviewedIndex];
    }
  }
}
